import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-text-input-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectModule,
    InputTextModule,
    NgIf,
  ],
  templateUrl: './text-input-field.component.html',
  styleUrl: './text-input-field.component.scss',
})
export class TextInputFieldComponent extends FieldType<
  FieldTypeConfig<FormlyFieldProps>
> {}
